const Select = require('../../../packages/button-like-select');
const signals = require('../../../signals/account/orders-list');

class OrderCreator {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data));
    }
}

module.exports = {
    constructor: OrderCreator,
    children: [
        {
            name: 'select',
            component: Select,
            props: {
                signalOnSelect: signals.onCreateOrder,
                signalOnToggle: signals.togglePopup
            },
            watcher: {
                options: ['account', 'orders', 'createOrder', 'options'],
                isDisable: ['account', 'orders', 'createOrder', 'isDisable'],
                isOpen: ['account', 'popups', 'createOrder', 'isOpen'],
                header: ['account', 'orders', 'createOrder', 'header']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/order-creator/index.js